import { render, staticRenderFns } from "./StyleDetails.vue?vue&type=template&id=326c12bc"
import script from "./StyleDetails.vue?vue&type=script&lang=js"
export * from "./StyleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports